<template>
    <div>
        <p v-if="errorUnauthenticated" class="error">
            Je bent niet geautoriseerd voor het orderstatussysteem, log in en uit om dit te verhelpen.
        </p>
        <p v-else-if="errorNotFound">
            De order is (nog) niet gevonden in het orderstatussysteem.<br/>
            <br />
            <span v-if="isOrderFromToday">
                Als deze order jonger is dan 15 minuten moet de logistieke afhandeling nog gestart worden.<br />
                Als de 15 minuten inmiddels verstreken zijn en de gegevens zijn hier nog steeds niet zichtbaar kunt u
                het beste contact opnemen met Omnistock.
            </span>
            <span v-else>
                Deze order is ouder dan vandaag en de logistieke afhandeling had al gestart moeten zijn. Neem contact op
                met Omnistock!<br />
                <br />
                Is de order ouder dan 3 maanden, dan is deze mogelijk opgeschoond en niet meer beschikbaar in de productie-omgeving.
            </span>
        </p>
        <p v-else-if="error" class="error">
            Er is iets misgegaan bij het ophalen van de leveringsverzoeken.
        </p>
        <p v-else-if="errorEmpty">
            Er zijn (nog) geen leveringsverzoeken voor deze order
        </p>
    </div>
</template>

<script>
export default {
    props: {
        errorUnauthenticated: {type: Boolean},
        errorNotFound: {type: Boolean},
        errorEmpty: {type: Boolean},
        error: {type: Boolean},
        isOrderFromToday: {type: Boolean, default: true},
    }
}
</script>

<style scoped>
    p {
        padding: 5px 0;
    }

    .error {
        color: #e00;
    }
</style>
